import brand01 from "../assets/brand/brand01.webp"
import brand02 from "../assets/brand/brand02.webp"
import brand03 from "../assets/brand/brand03.webp"
import brand04 from "../assets/brand/brand04.webp"
import brand05 from "../assets/brand/brand05.webp"
import brand06 from "../assets/brand/brand06.webp"
import brand07 from "../assets/brand/brand07.webp"
import brand08 from "../assets/brand/brand08.webp"
import brand09 from "../assets/brand/brand09.webp"
import brand10 from "../assets/brand/brand10.webp"
import brand11 from "../assets/brand/brand11.webp"
import brand12 from "../assets/brand/brand12.webp"
import brand13 from "../assets/brand/brand13.webp"
import brand14 from "../assets/brand/brand14.webp"
import brand15 from "../assets/brand/brand15.webp"

export const brandData = [
  {
    image: brand01,
    title: "우영미",
  },
  {
    image: brand02,
    title: "스톤 아일랜드",
  },
  {
    image: brand03,
    title: "샤넬",
  },
  {
    image: brand04,
    title: "스투시",
  },
  {
    image: brand05,
    title: "아미",
  },
  {
    image: brand06,
    title: "루이비통",
  },
  {
    image: brand07,
    title: "보테가 베네타",
  },
  {
    image: brand08,
    title: "롤렉스",
  },
  {
    image: brand09,
    title: "애플",
  },
  {
    image: brand10,
    title: "아더에러",
  },
  {
    image: brand11,
    title: "살로몬",
  },
  {
    image: brand12,
    title: "발렌시아가",
  },
  {
    image: brand13,
    title: "아크테릭스",
  },
  {
    image: brand14,
    title: "아이앱 스튜디오",
  },
  {
    image: brand15,
    title: "오니츠카 타이거",
  }
];
